// v4 (V4-D6 parity with the receipts / email_receipt tools): the Credits screen's Purchases list. GET /api/me/purchases,
// POST /api/me/purchases/:id/receipt. Under VITE_MOCK the purchases live in memory here, so the screen works in the mock.
import { call } from "./api";

export type Purchase = { n: number; id: string; packName: string; credits: number; usd: number; at: string };

const obj = (v: unknown): Record<string, unknown> => (v && typeof v === "object" ? (v as Record<string, unknown>) : {});
const num = (v: unknown) => (typeof v === "number" && Number.isFinite(v) ? v : 0);

/** The API's answer, checked: rows without an id or a date are dropped. */
export function normPurchases(raw: unknown): Purchase[] {
  const list = obj(raw).purchases;
  return (Array.isArray(list) ? list : [])
    .map(obj)
    .filter((p) => typeof p.id === "string" && typeof p.at === "string")
    .map((p, i) => ({ n: num(p.n) || i + 1, id: p.id as string, packName: typeof p.packName === "string" ? p.packName : "Credits", credits: num(p.credits), usd: num(p.usd), at: p.at as string }));
}

const isMock = () => import.meta.env?.VITE_MOCK === "1";
const MOCK: Purchase[] = [
  { n: 1, id: "cs_mock_2", packName: "Creator", credits: 2900, usd: 29, at: new Date(Date.now() - 2 * 86400_000).toISOString() },
  { n: 2, id: "cs_mock_1", packName: "1,250 credits", credits: 1250, usd: 15, at: new Date(Date.now() - 19 * 86400_000).toISOString() },
];

export async function loadPurchases(): Promise<Purchase[]> {
  if (isMock()) return MOCK.map((p) => ({ ...p }));
  return normPurchases(await call("GET", "me/purchases"));
}

/** Emails one purchase's receipt; true when it went. */
export async function emailReceipt(id: string): Promise<boolean> {
  if (isMock()) return true;
  const r = obj(await call("POST", `me/purchases/${encodeURIComponent(id)}/receipt`));
  return r.sent === "sent";
}
